import { render } from "./MainBox.vue?vue&type=template&id=29230bbc&scoped=true"
import script from "./MainBox.vue?vue&type=script&lang=js"
export * from "./MainBox.vue?vue&type=script&lang=js"

import "./MainBox.vue?vue&type=style&index=0&id=29230bbc&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29230bbc"]])

export default __exports__